var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUsersAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0095DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.09 25.5C25.09 25.78 24.87 26 24.59 26H7.41003C7.13003 26 6.91003 25.78 6.91003 25.5C6.91003 21.36 10.99 18 16 18C17.03 18 18.03 18.14 18.95 18.41C18.36 19.11 18 20.02 18 21C18 21.75 18.21 22.46 18.58 23.06C18.78 23.4 19.04 23.71 19.34 23.97C20.04 24.61 20.97 25 22 25C23.12 25 24.13 24.54 24.85 23.8C25.01 24.34 25.09 24.91 25.09 25.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.97 18.33C24.25 17.51 23.18 17 22 17C20.88 17 19.86 17.46 19.13 18.21C18.43 18.93 18 19.92 18 21C18 21.75 18.21 22.46 18.58 23.06C18.78 23.4 19.04 23.71 19.34 23.97C20.04 24.61 20.97 25 22 25C23.46 25 24.73 24.22 25.42 23.06C25.63 22.72 25.79 22.33 25.88 21.93C25.96 21.63 26 21.32 26 21C26 19.98 25.61 19.04 24.97 18.33ZM23.5 21.73H22.75V22.51C22.75 22.92 22.41 23.26 22 23.26C21.59 23.26 21.25 22.92 21.25 22.51V21.73H20.5C20.09 21.73 19.75 21.39 19.75 20.98C19.75 20.57 20.09 20.23 20.5 20.23H21.25V19.52C21.25 19.11 21.59 18.77 22 18.77C22.41 18.77 22.75 19.11 22.75 19.52V20.23H23.5C23.91 20.23 24.25 20.57 24.25 20.98C24.25 21.39 23.91 21.73 23.5 21.73Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C18.7614 16 21 13.7614 21 11C21 8.23858 18.7614 6 16 6C13.2386 6 11 8.23858 11 11C11 13.7614 13.2386 16 16 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUsersAlt);
export default __webpack_public_path__ + "static/media/u_users-alt.73818fbb1aedb8fa0fa01b8cbff31bd7.svg";
export { ForwardRef as ReactComponent };